import React from 'react';
import { FormattedMessage } from 'react-intl';
import { APP_BASENAME } from '../config';

const PageNotFound = () => (
  <div className="p-grid p-justify-center p-align-center pageNotFound">
    <div className="p-col-12">
      <img src={`${APP_BASENAME}/images/gr8pi-404-dark.svg}`} alt="Page not found logo" />
    </div>
    <div className="p-col-12 p-md-6">
      <h1>
        <FormattedMessage id="components.page-not-found.heading-01" defaultMessage="oops!! nothing was found" />
      </h1>
      <p>
        <FormattedMessage
          id="components.page-not-found.not-found-text"
          // eslint-disable-next-line max-len
          defaultMessage="The page you are looking for might have been removed, had its name changed or is temporarily unavailable."
        />
      </p>
    </div>
  </div>
);
export default PageNotFound;
